import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import * as React from "react";

export const wordsLimit = 255
export const pageLimit = 5
export const servicerIDLimit = 5

export const ApproveOrReject = {
  APPROVE: 'APPROVED',
  REJECT: 'REJECTED',
  SUBMITTED: 'SUBMITTED',
  CANCELED: 'CANCELED',
}

export const UserStatus = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  DELETED: 'DELETED',
  LOCKED: 'LOCKED',
}

export const ServicerStatus = {
  OPT_OUT: 'OPT OUT FOR THIS FY',
  OPTOUT_REJECTED: 'OPT OUT REJECTED',
  PRIVATE: 'PRIVATE ACTIVE',
  PUBLIC_ACTIVE: 'PUBLIC ACTIVE',
  PUBLIC_PROVISIONED: 'PUBLIC PROVISIONED ACTIVE'
}


export const UserRole = {
  APPROVER: 'APPROVER',
  ADMIN: 'ADMIN',
  SERVICER: 'SERVICER',
  SERVICER_COORDINATOR: 'SERVICER COORDINATOR',
}

export const getTrainingTableHeaders = userRole => {
  switch (userRole) {
    case UserRole.SERVICER_COORDINATOR:
      return [
        'Training Name',
        'Training Type',
        'Trainee Email',
        'Trainee Name',
        'Completion Date',
        'Submitted Date',
        'Hours',
        'Training Status'
      ]
    case UserRole.SERVICER:
      return [
        'Training Name',
        'Training Type',
        'Completion Date',
        'Submitted Date',
        'Hours',
        'Training Status'
      ]
    case UserRole.ADMIN:
    case UserRole.APPROVER:
      return [
        'FiscalYear',
        'Servicer ID',
        'Servicer Name',
        'Trainee Email',
        'Trainee Name',
        'Training Name',
        'Training Type',
        'Standard Training Name',
        'Completion Date',
        'Submitted Date',
        'Hours',
        'Training Status'
      ]
  }
}


export const targetTableToDownload = {
  trainingTable: 'trainingTable',
  creditTable: 'creditTable',
  userTable: 'userTable',
  servicerTable: 'servicerTable',
  trainingNameTable: 'trainingNameTable'
  
}

export const fiscalYearOptions = [
  { value: '2024', label: 'FY2024' },
  { value: '2025', label: 'FY2025' },
];

export const getCreditTableHeaders = [
  'Fiscal Year',
  'Servicer ID',
  'Servicer Name',
  'Approved LiveTraining',
  'LiveTraining Credits',
  'Approved EClass',
  'Approved EClass (Mandatory)',
  'EClass Credits',
  'Approved Webinar',
  'Webinar Credits',
  'Training Credits'
]

export const getTrainingNameTableHeaders = [
  'Fiscal yr',
  'Standardized Training Type',
  'Standardized Training Name',
  
]

export const getServicerTableHeader = [
  'Servicer ID',
  'Servicer Name',
  'Created On',
  'Updated On',
  'TRSII Opt-In',
]

export const getManageUserTableHeaders = [
  'First Name',
  'Last Name',
  'Email',
  'User Role',
  'Servicer ID',
  'Servicer Name',
  'Created At',
  'Updated At',
]


export const getManageServicerTableHeaders = [
  'Servicer ID',
  'Servicer Master',
  'trsiiOptIn',
  'optOutFlag'
]

export const createOrUpdateEnum = {
  create: 'create',
  update: 'update',
  delete: 'delete',
}



export const getTrainingPageFilters = (role) => {
  let sortingList = [
    {
      label: "Training Name",
      value: 2,
    },
    {
      label: "Training Status",
      value: 9,
    },
    {
      label: "Training Type",
      value: 10,
    },
    {
      label: "Start Date",
      value: 14,
    },
    {
      label: "End Date",
      value: 15,
    },
    {
      label: "Hours",
      value: 19,
    },
  ];

  if (UserRole.SERVICER_COORDINATOR === role) {
    sortingList.push({
      label: "Trainee Name",
      value: 23,
    });
    sortingList.push({
      label: "Trainee Email",
      value: 24,
    });
  }
  if (UserRole.ADMIN === role || UserRole.APPROVER === role) {
    sortingList.push({
      label: "Servicer Name",
      value: 21,
    });
    sortingList.push({
      label: "Servicer ID",
      value: 22,
    });
    sortingList.push({
      label: "User Name",
      value: 23,
    });

    sortingList.push({
      label: "User Email",
      value: 24,
    });
    
  }
  return sortingList
}
export const sortingSystem = {
  trainingPage: {
    defaultSortValue: 2,
    trainingPageSortBy: [
      // {
      //   label: "Latest Created",
      //   value: 1,
      // },
      {
        label: "Training Name",
        value: 2,
      },
      {
        label: "Training Status",
        value: 9,
      },
      {
        label: "Training Type",
        value: 10,
      },
      {
        label: "Trainee Name",
        value: 13,
      },
      {
        label: "Start Date",
        value: 14,
      },
      {
        label: "End Date",
        value: 15,
      },
    ],
  },

  creditPage: {
    defaultSortValue: 3,
    creditPageSortBy: [
      {
        label: "Servicer Name",
        value: 3,
      },
      {
        label: "Servicer ID",
        value: 7,
      },
      {
        label: "Training Type",
        value: 12,
      },
    ],
  },

  TrainingNamesPage: {
    defaultSortValue: 22,
    sortOpts: [
      {
        label: "Fiscal yr",
        value: 22,
      },
      {
        label: "Standardized Training Type",
        value: 19,
      },
      {
        label: "Standardized Training Name",
        value: 20,
      },
    ],
  },

  userMaintenancePage: {
    defaultSortValue: 4,
    sortOpts: [
      {
        label: "User Name",
        value: 4,
      },
      {
        label: "Email",
        value: 16,
      },
      {
        label: "Servicer Name",
        value: 5,
      },
      {
        label: "User Role",
        value: 6,
      },
      {
        label: "Servicer ID",
        value: 8,
      },

      {
        label: "Created On",
        value: 17,
      },
    ],
  },

  servicerMaintenancePage: {
    defaultSortValue: 5,
    sortOpts: [
      {
        label: "Created On",
        value: 11,
      },
      {
        label: "Servicer ID",
        value: 7,
      },
      {
        label: "Servicer Name",
        value: 5,
      },
      {
        label: "Updated On",
        value: 18,
      },
    ],
  },
}